import React from "react";
import PropTypes from "prop-types";

import { Menu } from "semantic-ui-react";

export function NavigationBar({
  items,
  selected,
  onSelected,
  disabled,
  ...props
}) {
  const itemStyles = {
    fontSize: "20px",
    cursor: "pointer",
    paddingLeft: ".8em",
    marginTop: "0em",
  };
  const selectedStyles = {
    ...itemStyles,
    backgroundColor: "rgba(83, 109, 254, .5)",
    borderRadius: "25px",
    fontWeight: "bold",
  };

  return (
    <Menu text vertical {...props}>
      {items.map(({ name, slug }) => {
        return (
          <Menu.Item
            key={slug}
            disabled={disabled && selected !== slug}
            style={selected === slug ? selectedStyles : itemStyles}
            active
            name={name}
            onClick={() => {
              return onSelected(slug);
            }}
          />
        );
      })}
    </Menu>
  );
}

NavigationBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, slug: PropTypes.string })
  ).isRequired,
  selected: PropTypes.string.isRequired,
  onSelected: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

NavigationBar.defaultProps = {
  disabled: false,
};

export default NavigationBar;
